import React from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import { connect } from 'react-redux'
import Avatar from 'material-ui/Avatar'
import Divider from 'material-ui/Divider'

const styles = {
  avatarWrapper:{
    textAlign: 'center',
  },
  description:{
    fontWeight: 'bold',
    color: '#F58A15',
  },
}

class MedalDialog extends React.Component {

  handleClose = () => {
    this.props.toggleOpen()
  }

  render() {
    const { name, image_url, description, credits } = this.props
    const actions = [
      <FlatButton
        label="OK"
        primary
        onTouchTap={this.handleClose}
      />,
    ]

    return (
      <Dialog
        title={name}
        modal={false}
        actions={actions}
        open={this.props.open}
        onRequestClose={this.handleClose}
      >
        <div style={styles.avatarWrapper}>
          <Avatar src={image_url} size={100} />
        </div>
        <div style={styles.description}>DESCRIPCIÓN</div>
        <Divider inset={false} />
        <br/>
        <div dangerouslySetInnerHTML={{ __html: description||(`Medalla sin descripción.`) }}></div>
        <br/>
        <br/>
        <strong>Créditos: {(credits||0).toLocaleString()}</strong>
      </Dialog>
    )
  }

}

MedalDialog.propTypes = {
  open: React.PropTypes.bool.isRequired,
  toggleOpen: React.PropTypes.func.isRequired,
}

const mapStateToProps = state => ({ ...state.user.selectedMedal, })

const mapDispatchToProps = dispatch => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(MedalDialog)



// WEBPACK FOOTER //
// ./src/components/Main/MedalDialog/index.jsx